//Blocked for now, dynamic imports causes many requests and hight cost
//In prod we take assets from AWS S3.
import liveScoreboardsApp from "./ScoreboardOverview/liveScoreboardsApp";
import manageOrganizersApp from "./ManageOrganizers/manageOrganizers";
import adminRegisteredCompetitorsApp from "./RegisteredCompetitors/adminRegisteredCompetitorsApp";
import techAccountSetup from "./TechAccount/techAccountSetup";
import bracketsListingApp from "./Brackets/Listing/bracketsListingApp";
import invitationLinksApp from "./InvitationLinks/invitationLinksApp";
import editEventApp from "./Admin/editEventApp";
import adminWelcomePageV2 from "./AdminWelcomePage/adminWelcomePageV2";
import competitorsVerificationApp from "./CompetitorsVerification/competitorVerificationApp";
import competitorResults from "./Reports/competitorResults";
import initEventAdminUsersViewApp from "./Users/eventAdminUsersViewApp";
import initScheduleManageApp from "./Schedules/Managing/scheduleManageApp";
import initAcademyResultsApp from "./Reports/academyResultsApp";
import initCoachPassesApp from "./CoachPasses/coachPassesApp";
import initRefereeFightsApp from "./Fights/refereeFightsApp";
import initFightsManageApp from "./Fights/fightsManageApp";
import initAllFinishedFightsApp from "./Fights/allFinishedFightsApp";
import initScheduleListingApp from "./Schedules/schedulesListing";
import initScheduleStatusApp from "./Schedules/scheduleStatusApp";
import initSharingOnTvApp from "./Sharing/sharingOnTvApp";
import initMangeEventsApp from "./Admin/manageEventsApp";
import initCategoriesManagerApp from "./CategoriesManager/categoriesManagerApp";
import initCategoriesSummaryApp from "./CategoriesSummary/categoriesSummaryApp";
import initCreateBracketApp from "./Brackets/createBracket";
import initShowBracketApp from "./Brackets/showBracket";
import initPricingSetupApp from "./PricingSetup/pricingSetupApp";
import initCreateNotificationApp from "./NotificationsCenter/createNotification";
import initNotificationListingApp from "./NotificationsCenter/notificationListing";
import initLiveStreamsManageApp from "./LiveStreams/liveStreamsManageApp";
import initPublicFightsQueue from "./PublicFightsQueue/publicFightsQueueApp";
import initAnnouncerBoard from "./AnnouncerBoard/announcerBoardApp";
import initAdminCompetitorRankingsApp from "./EventRankings/adminEventRankingsApp";
import { PropsToInstance } from "./Common/vueApp";
import adminVouchersApp from "./AdminVouchers/adminVouchersApp";
import auditLogsApp from "./AuditLogs/auditLogsApp";
import initFederationsListingApp from "./Federations/federationsListingApp";
import federationDashboardApp from "./Federations/federationDashboardApp";
import initMatsManagementApp from "./MatManagement/matsManagementApp";
import initDisciplinePackagesApp from "./DisciplinePackages/disciplinePackagesApp";
import initCreateEventWizardApp from "./Admin/CreateEventWizard/createEventWizardApp";

function initApp(importPromise: PropsToInstance): PropsToInstance {
    return importPromise;
}

window.panelBundles = {
    //admin pages
    initEventAdminUsersViewApp: initApp(initEventAdminUsersViewApp),
    initScheduleManageApp: initApp(initScheduleManageApp),
    initAcademyResultsApp: initApp(initAcademyResultsApp),
    initCoachPassesApp: initApp(initCoachPassesApp),
    initRefereeFightsApp: initApp(initRefereeFightsApp),
    initFightsManageApp: initApp(initFightsManageApp),
    initAllFinishedFightsApp: initApp(initAllFinishedFightsApp),
    initScheduleListingApp: initApp(initScheduleListingApp),
    initScheduleStatusApp: initApp(initScheduleStatusApp),
    initCompetitorResultsApp: initApp(competitorResults),
    initAdminWelcomePageAppV2: initApp(adminWelcomePageV2),
    initCompetitorsVerificationApp: initApp(competitorsVerificationApp),
    initEditEventApp: initApp(editEventApp),
    initSharingOnTvApp: initApp(initSharingOnTvApp),
    initMangeEventsApp: initApp(initMangeEventsApp),
    initCategoriesManagerApp: initApp(initCategoriesManagerApp),
    initCategoriesSummaryApp: initApp(initCategoriesSummaryApp),
    initCreateBracketApp: initApp(initCreateBracketApp),
    initShowBracketApp: initApp(initShowBracketApp),
    initPricingSetupApp: initApp(initPricingSetupApp),
    initInvitationLinksApp: initApp(invitationLinksApp),
    initBracketsListingApp: initApp(bracketsListingApp),
    initTechAccountSetupApp: initApp(techAccountSetup),
    initCreateNotificationApp: initApp(initCreateNotificationApp),
    initNotificationListingApp: initApp(initNotificationListingApp),
    initAdminRegisteredCompetitorsApp: initApp(adminRegisteredCompetitorsApp),
    initLiveScoreboardsApp: initApp(liveScoreboardsApp),
    initAdminVouchersApp: initApp(adminVouchersApp),
    initManageOrganizersApp: initApp(manageOrganizersApp),
    initPublicFightsQueue: initApp(initPublicFightsQueue),
    initLiveStreamsManageApp: initApp(initLiveStreamsManageApp),
    initAnnouncerBoard: initApp(initAnnouncerBoard),
    initAdminCompetitorRankingsApp: initApp(initAdminCompetitorRankingsApp),
    initAuditLogsApp: initApp(auditLogsApp),
    initFederationsListingApp: initApp(initFederationsListingApp),
    initFederationDashboardApp: initApp(federationDashboardApp),
    initMatsManagementApp: initApp(initMatsManagementApp),
    initDisciplinePackagesApp: initApp(initDisciplinePackagesApp),
    initCreateEventWizardApp: initApp(initCreateEventWizardApp),
};
